var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name != null)?[_c(_vm.currentView,{tag:"component"},[_c('router-view')],1)]:_c('div',{staticStyle:{"height":"100vh"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }